import React from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { designTokens } from '../../styles/designTokens';
import Button from '../Button';

const useStyles = makeStyles((theme) => ({
    dialog: {},
    dialogPaper: {
        borderRadius: designTokens.borderRadius.modal,
        minWidth: '420px',
        maxWidth: '420px',
        padding: designTokens.spacing.xl,
        margin: designTokens.spacing.xxl,
        '@media (max-width: 600px)': {
            minWidth: 'calc(100vw - 32px)',
            maxWidth: 'calc(100vw - 32px)',
            margin: designTokens.spacing.lg,
            padding: '20px',
        }
    },
    header: {
        position: 'relative',
        minHeight: '24px',
        marginBottom: designTokens.spacing.xs,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
    },
    closeButton: {
        color: designTokens.colors.text.secondary,
        padding: designTokens.spacing.xs,
        marginLeft: 'auto',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        }
    },
    content: {
        padding: '0 !important',
    },
    title: {
        ...designTokens.typography.h2,
        marginBottom: designTokens.spacing.md,
        color: designTokens.colors.text.primary,
        '@media (max-width: 600px)': {
            fontSize: '18px',
        }
    },
    text: {
        ...designTokens.typography.body,
        color: designTokens.colors.text.secondary,
        marginBottom: designTokens.spacing.xl,
        whiteSpace: 'pre-line',
    },
    actions: {
        display: 'flex',
        gap: designTokens.spacing.sm,
        justifyContent: 'flex-end',
        '@media (max-width: 600px)': {
            flexDirection: 'column-reverse',
            '& > button': {
                width: '100%',
            }
        }
    }
}));

const ConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
    title = 'Підтвердження',
    text,
    confirmText = 'Так',
    cancelText = 'Ні',
    confirmVariant = 'primary'
}) => {
    const classes = useStyles();

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={classes.dialog}
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogContent className={classes.content}>
                <div className={classes.title}>{title}</div>
                <div className={classes.text}>{text}</div>

                <div className={classes.actions}>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        size="medium"
                    >
                        {cancelText}
                    </Button>
                    <Button
                        variant={confirmVariant}
                        onClick={handleConfirm}
                        size="medium"
                    >
                        {confirmText}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ConfirmationDialog;
